import { render, staticRenderFns } from "./ChildcareRateDetail.vue?vue&type=template&id=3dcc43ad&"
import script from "./ChildcareRateDetail.vue?vue&type=script&lang=js&"
export * from "./ChildcareRateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports